import React from 'react';
import { Container } from './styles';

interface ToolButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabledPopoverText: string;
  onButtonClick: any;
  buttonClass: string;
  buttonName: string;
  disabledButton: boolean;
}

const ToolButton = (props: ToolButtonProps) => {
  const { disabledPopoverText, onButtonClick, buttonClass, buttonName, disabledButton } = props;

  if (disabledButton) {
    return (
      <Container className="d-inline-block databalloon">
        <button type="button" className={buttonClass} title={buttonName} onClick={onButtonClick}>
          {buttonName}
        </button>
      </Container>
    );
  }
  return (
    <Container
      className="d-inline-block databalloon"
      aria-label={disabledPopoverText || ''}
      data-balloon-pos="down"
      data-balloon-length="medium"
    >
      <button
        type="button"
        className={buttonClass}
        title={buttonName}
        style={{ pointerEvents: 'none' }}
        onClick={onButtonClick}
        disabled
      >
        {buttonName}
      </button>
    </Container>
  );
};

export default ToolButton;
